import { ChangeEvent, useState } from "react"
import BannersTemplate1Form from "./forms/BannersTemplate1Form.tsx";
import UtilsHelper from "../../../../helpers/utilsHelper.ts";

export const AccountManagementBannersAddNew = () => {
    UtilsHelper.changeWindowDocumentTitle("Dodawanie baneru");
    const [selectedTemplate, setSelectedTemplate] = useState(0);

    const handleSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setSelectedTemplate(Number(event.target.value));
    };

    return (
        <div className="max-w-lg">
            <h1 className="text-3xl">Dodaj nowy baner</h1>
            <div className="h-0.5 w-28 bg-sky-500 my-4 rounded-r-full" />
            <div className={"bg-neutral-900 p-6 md:p-10 max-w-lg shadow-3xl rounded-3xl"}>
                <div className={"flex flex-col"}>
                    <label htmlFor="template">Wybierz szablon:</label>
                    <select
                        className={`mb-4 appearance-none bg-neutral-600 rounded-full text-white border border-neutral-700 px-3 py-2 mt-2 ring-2 ring-offset-2 ring-transparent focus:ring-[#008DD2] ring-offset-neutral-800 outline-none transition-all`}
                        id="template" value={selectedTemplate} onChange={handleSelectChange}>
                        <option value="">-- Wybierz szablon --</option>
                        <option value="1">Szablon 1</option>
                    </select>
                    {selectedTemplate === 1 &&
                        <BannersTemplate1Form mode={"create"} />
                    }
                </div>
            </div>
        </div>
    )
}
